import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import { addMonths } from 'date-fns';
import ButtonSp from '../../components/ButtonSp';
import DropDownLazy from '../../components/DropdownLazy';
import DropdownSp from '../../components/DropdownSp';

import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import VersaoSistemaService from '../../services/VersaoSistemaService';

import SistemaService from '../../services/SistemaService';

import { carregaListaVersoes, errorHandle, validateFields } from '../../util/functions';
import { VersaoSistemaModel } from '../../util/Models';
import { StateScreen } from '../constants';
import CalendarSp from '../../components/CalendarSp';
import { cfgPtBr } from '../../config/Constantes';
import InputTextareaSp from '../../components/InputTextareaSp';
import DesenvolvimentoService from '../../services/DesenvolvimentoService';

function VersaoSistemaCrud(props) {
  VersaoSistemaCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  VersaoSistemaCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [versaoSistema, setVersaoSistema] = useState(new VersaoSistemaModel());
  const [versaoSistemaSelecionado, setSistemaSelecionado] = useState(null);

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);
  const [disponivelOld, setDisponivelOld] = useState(false);

  // useCallbacks

  const handleImportarHistorico = async () => {
    const filterDev = DesenvolvimentoService.getFilter();
    filterDev.limit = 999;
    filterDev.dataInicio = addMonths(new Date(), -36);
    filterDev.dataFim = addMonths(new Date(), 36);
    filterDev.idSistema = versaoSistema.idSistema;
    filterDev.versaoLiberacao = versaoSistema.versao;
    const historico = await DesenvolvimentoService.getHistorico(
      versaoSistema.idSistema,
      versaoSistema.versao
    );

    setVersaoSistema({ ...versaoSistema, historico: historico.historico });
  };
  const loadSistema = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await SistemaService.findAll({ nome: _nome, limit: 50 });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await VersaoSistemaService.findById(_id);
      let versaoSistemaTemp;
      setDisponivelOld(retorno.disponivel);

      setVersaoSistema({ ...retorno, data: new Date(retorno.data) });
      if (retorno) {
        versaoSistemaTemp = {
          label: retorno.sistema.nome,
          value: retorno.sistema.id,
        };
      }

      setSistemaSelecionado(versaoSistemaTemp);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      let mensagem = 'Confirma os dados';
      if (versaoSistema.disponivel && versaoSistema.disponivel !== disponivelOld) {
        mensagem = 'Os desenvolvimentis vinculados serão alteradas para o status "Liberado"';
      }
      showMessage('Confirmação', mensagem, idx => {
        if (idx === 1) {
          salvarRecord();
        }
      });
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      if (stateScreen === StateScreen.stInsert) {
        retorno = await VersaoSistemaService.insert(versaoSistema);
      } else {
        retorno = await VersaoSistemaService.update(versaoSistema);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new VersaoSistemaModel();
      setSistemaSelecionado(null);

      setVersaoSistema(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <div className="p-col-6 p-sm-3 p-lg-2 p-fluid">
        <LabelSp>Data</LabelSp>
        <CalendarSp
          showOnFocus={false}
          showIcon
          required
          dateFormat="dd/mm/yy"
          disabled={viewMode()}
          locale={cfgPtBr}
          value={versaoSistema.data}
          appendTo={document.body}
          onChange={e => {
            setVersaoSistema({
              ...versaoSistema,
              data: e.target.value,
            });
          }}
        />
      </div>
      <div className="p-col-6 p-sm-4 p-lg-5 p-fluid">
        <LabelSp>Sistema</LabelSp>
        <DropDownLazy
          required
          autoLoad
          disabled={viewMode()}
          placeholder="Selecione"
          onChange={e => {
            const versaoSistemaTemp = e ? { id: e.value, nome: e.label } : null;
            setVersaoSistema({
              ...versaoSistema,
              sistema: versaoSistemaTemp,
              idSistema: e?.value || null,
            });
          }}
          value={versaoSistemaSelecionado}
          onFilter={async txtFilter => {
            const retorno = await loadSistema(txtFilter);
            return retorno;
          }}
        />
      </div>

      <div className="p-col-6 p-sm-3 p-lg-3 p-fluid">
        <LabelSp>Versão</LabelSp>
        <DropdownSp
          filter
          options={carregaListaVersoes(false)}
          placeholder="selecione"
          required
          disabled={viewMode()}
          value={versaoSistema.versao}
          onChange={e => {
            setVersaoSistema({ ...versaoSistema, versao: e.target?.value });
          }}
        />
      </div>

      <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
        <LabelSp>Disponível?</LabelSp>
        <DropdownSp
          required
          value={versaoSistema.disponivel}
          options={[
            { label: 'Sim', value: true },
            { label: 'Não', value: false },
          ]}
          disabled={viewMode()}
          filterInputAutoFocus={false}
          onChange={e => {
            setVersaoSistema({ ...versaoSistema, disponivel: e.target.value });
          }}
        />
      </div>

      <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
        <LabelSp>Histórico da Versão</LabelSp>
        <div style={{ display: 'flex' }}>
          <InputTextareaSp
            required
            autoResize={false}
            value={versaoSistema.historico}
            // maxLength={99}
            rows={10}
            resize={false}
            onChange={e => {
              setVersaoSistema({
                ...versaoSistema,
                historico: e.target.value,
              });
            }}
            disabled={viewMode()}
          />
          <div
            style={{
              marginLeft: 5,
              flex: 1,
            }}
          >
            <ButtonSp
              className="buttons p-button-warning"
              label=""
              disabled={viewMode()}
              icon="pi pi-ellipsis-h"
              title="Importar dos desenvolvimentos"
              style={{ marginRight: 0 }}
              onClick={() => {
                if (!versaoSistema.idSistema) {
                  toast.warn('Informa o sistema.');
                  return;
                }

                if (!versaoSistema.versao) {
                  toast.warn('Informa a versão.');
                  return;
                }
                showMessage(
                  'Atenção?',
                  'Deseja importas o histórico dos desenvolvimentos?',
                  idx => {
                    if (idx === 1) {
                      handleImportarHistorico();
                    }
                  }
                );
              }}
            />
          </div>
        </div>
      </div>

      <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
        {!viewMode() ? (
          <ButtonSp
            className="p-button-success"
            icon="pi pi-save"
            label="Salvar"
            keyAccess="S"
            disabled={
              !validateFields(versaoSistema, ['data', 'idSistema', 'versao', 'historico'])
            }
            onClick={handleSave}
          />
        ) : null}
        <ButtonSp
          className="p-button-secondary"
          label="Voltar"
          keyAccess="V"
          icon="pi pi-chevron-circle-left"
          onClick={handleBack}
        />
      </div>
    </>
  );
}

export default VersaoSistemaCrud;
